import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";

// Mobile-only tap-to-call button (bottom-right), so visitors can call instantly.
export default function MobileCallButton() {
  const { pathname } = useLocation();

  if (pathname.startsWith("/admin")) return null;
  if (pathname.startsWith("/contact")) return null;

  return (
    <a
      href="tel:+14382556438"
      data-testid="mobile-call-button"
      aria-label="Appeler Reflectum Pellicule"
      className="sm:hidden fixed bottom-4 right-4 z-40 w-14 h-14 rounded-full bg-[#0F1012] text-[#C5A880] grid place-items-center shadow-xl shadow-black/20 border border-[#C5A880]/30 transition-transform active:scale-95"
    >
      <Phone className="w-5 h-5" strokeWidth={2} />
    </a>
  );
}
